import { createFileRoute } from '@tanstack/react-router'
import {
  Nav,
  Hero,
  Problem,
  Solution,
  HowItWorks,
  TargetUsers,
  Monetization,
  RevenueForecast,
  WhyDubai,
  PlatformPotential,
  ContactForm,
  Footer,
} from '@/components/urban-maps'

export const Route = createFileRoute('/_public/')({
  component: UrbanMapsLanding,
})

function UrbanMapsLanding() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0a0f14]">
      <Nav />
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <TargetUsers />
      <Monetization />
      <RevenueForecast />
      <WhyDubai />
      <PlatformPotential />
      <ContactForm />
      <Footer />
    </div>
  )
}
